import React from 'react'
import { Form, InputNumber, Select } from 'antd'
import CurrencyService from '../../service/CurrencyService'
import { groupThousands } from '../../util/format'

const toOptions = (currencies: string[]) => currencies.map((currency) => ({ label: currency, value: currency }))

const currencyOptions = [
    { label: 'Most used', options: toOptions(CurrencyService.mostUsedCurrencies) },
    { label: 'Others', options: toOptions(CurrencyService.allCurrencies) },
]

interface AmountFieldProps {
    label: string
    // Payload field for the currency ('currency' or 'currencyId')
    currencyName: string
}

const AmountField: React.FC<AmountFieldProps> = ({ label, currencyName }) => (
    <Form.Item name="amount" label={label} rules={[{ required: true, message: `Please enter the ${label.toLowerCase()}` }]}>
        <InputNumber<string | number>
            min={0}
            style={{ width: '100%' }}
            placeholder="0.00"
            formatter={groupThousands}
            parser={(value) => (value ?? '').replace(/,/g, '')}
            addonAfter={
                <Form.Item name={currencyName} noStyle rules={[{ required: true, message: 'Please pick a currency' }]}>
                    <Select showSearch placeholder="Currency" style={{ width: 110 }} options={currencyOptions} aria-label="Currency" />
                </Form.Item>
            }
        />
    </Form.Item>
)

export default AmountField
